import React from 'react'

const NotFound = () => {
  return (
    <p className='text-center'>
      Page not found. Please chooose a different option from the dropdown.
    </p>
  )
}

export default NotFound
